import {
  DollarOutlined,
  TeamOutlined,
  UserOutlined,
  ClockCircleOutlined,
} from '@ant-design/icons';

export default {
  programs: [
    {
      name: 'STAR Summer Camp',
      href: 'https://reg.starsacramento.org',
    },
    {
      name: 'STAR Galaxy|ELO-P',
      href: 'https://reg.starsacramento.org',
    },
  ],
  menuItems: [
    {
      label: 'Account Summary',
      icon: <UserOutlined />,
      path: '/',
      primaryRequired: false,
    },
    {
      label: 'Primary Guardian',
      icon: <UserOutlined />,
      path: '/primary',
      primaryRequired: false,
    },
    {
      label: 'Additional Guardians',
      icon: <TeamOutlined />,
      path: '/additional-guardians',
      primaryRequired: true,
    },
    {
      label: 'Emergency Contacts',
      icon: <TeamOutlined />,
      path: '/emergency-contacts',
      primaryRequired: true,
    },
    {
      label: 'Students',
      icon: <UserOutlined />,
      path: '/students',
      primaryRequired: true,
    },
    {
      label: 'Attendance Tracker',
      icon: <ClockCircleOutlined />,
      path: '/attendance',
      primaryRequired: true,
    },
    {
      label: 'Ledger',
      icon: <DollarOutlined />,
      path: '/ledger',
      primaryRequired: true,
    },
    {
      label: 'AutoPay',
      icon: <DollarOutlined />,
      path: '/autoPay',
      primaryRequired: true,
    },
  ],
};
